// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".v64." + "e11f0515a0a29ddfeda0" + ".js";
};